module.exports = __webpack_public_path__ + "img/letras_healthtech_sandbox.9bcf4f81.jpg";